import { useEffect, useState } from "react";
import { AnimatePresence, motion } from "framer-motion";

/**
 * Ken-Burns cross-fade slideshow.
 * - If only ONE image is provided, renders it statically (with a slow scale drift for character).
 * - If MULTIPLE, cross-fades between them every `interval` ms with a slow pan/scale on each.
 */
export default function KenBurnsHero({ images, interval = 6500, className = "" }) {
  const [i, setI] = useState(0);

  useEffect(() => {
    if (!images || images.length < 2) return;
    const t = setInterval(() => {
      setI((prev) => (prev + 1) % images.length);
    }, interval);
    return () => clearInterval(t);
  }, [images, interval]);

  if (!images || images.length === 0) return null;

  // Alternate pan direction so it doesn't feel mechanical
  const panDirection = i % 2 === 0 ? 1 : -1;

  return (
    <div className={`relative w-full h-full overflow-hidden ${className}`}>
      <AnimatePresence mode="sync">
        <motion.div
          key={images[i]}
          className="absolute inset-0"
          initial={{ opacity: 0, scale: 1.0 }}
          animate={{ opacity: 1, scale: 1.12, x: 20 * panDirection, y: -10 * panDirection }}
          exit={{ opacity: 0, scale: 1.15 }}
          transition={{
            opacity: { duration: 2.2, ease: [0.4, 0, 0.2, 1] },
            scale: { duration: interval / 1000 + 2, ease: "linear" },
            x: { duration: interval / 1000 + 2, ease: "linear" },
            y: { duration: interval / 1000 + 2, ease: "linear" },
          }}
        >
          <img
            src={images[i]}
            alt=""
            className="w-full h-full object-cover vintage-img"
            draggable={false}
          />
        </motion.div>
      </AnimatePresence>
    </div>
  );
}
